import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import LinearProgress from "@mui/material/LinearProgress";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import NavNotLoggedIn from "../components/NavNotLoggedIn";
import { MdError, MdDone } from "react-icons/md";
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from "react-icons/md";

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  field: {
    width: 360,
    ["& fieldset"]: {
      borderRadius: 10,
    },
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "51px",
    height: "51px",
  },
}));

function LogIn(props) {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [openWait, setOpenWait] = useState(false);
  const [openFailed, setOpenFailed] = useState(false);
  const [openForgotPass, setOpenForgotPass] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [radio, setRadio] = useState(false);
  const [showPass, setShowPass] = useState(false);

  // Ouverture modal de confirmation d'envoie email de recuperation de mdp
  const [resetEmail, setResetEmail] = useState(false);
  // Ouverture modal pour informer que l'email reset a échoué
  const [failResetEmail, setFailResetEmail] = useState(false);

  let tokenStorage = null;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogIn();
    }
  };
  // Appel API, envoie de l'email et password pour verification de l'existence du compte
  const handleLogIn = async () => {
    setOpenWait(true);
    try {
      const dataLogIn = await fetch(
        "https://bck-bdx.carloapp.com/api/business/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Version: "4.0",
          },
          body: `email=${encodeURIComponent(email)}&password=${password}`,
        }
      );

      // Check if the response is ok before parsing
      if (!dataLogIn.ok) {
        throw new Error(`HTTP error! status: ${dataLogIn.status}`);
      }

      // Recuperation de la reponse de l'API et redirection vers le home screen si positif
      const body = await dataLogIn.json();
      // console.log(">>body", body);
      if (body.status === true && body.message === "") {
        localStorage.setItem("token", JSON.stringify(body.data.token));
        localStorage.setItem("shopId", body.data.shop_id);
        localStorage.setItem("email", body.data.email);
        localStorage.setItem("refferalCode", body.data.referral_code);

        props.onSetToken(body.data.token);
        setIsLogin(true);
        setOpenWait(false);
      } else {
        setOpenFailed(true);
        setOpenWait(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      setOpenWait(false);
      setOpenFailed(true);
    }
  };

  const handleClickShowPassword = () => {
    setShowPass(!showPass);
  };

  // Ouverture et fermeture modal pour oublie de mdp
  const handleForgotPass = () => {
    setOpenForgotPass(true);
  };
  const handleClose = () => setOpenForgotPass(false);

  // Appel API, envoie de l'email pour reinitialisation du mdp
  const handleConfirmForgotPass = async () => {
    setOpenWait(true);
    setOpenForgotPass(false);
    try {
      const dataForgotPassword = await fetch(
        "https://bck-bdx.carloapp.com/api/business/reset_password",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Version: "4.0",
          },
          body: `email=${forgotEmail}`,
        }
      );

      // Check if the response is ok before parsing
      if (!dataForgotPassword.ok) {
        throw new Error(`HTTP error! status: ${dataForgotPassword.status}`);
      }

      const bodyForgotPass = await dataForgotPassword.json();
      if (bodyForgotPass.status === true) {
        setResetEmail(true);
        setOpenWait(false);
      } else {
        setFailResetEmail(true);
        setOpenWait(false);
      }
    } catch (error) {
      console.error("Reset password error:", error);
      setOpenWait(false);
      setFailResetEmail(true);
    }
  };

  // Redirect user if logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  if (isLoggedIn) {
    return <Redirect to="/home" />;
  }

  return (
    <div>
      <NavNotLoggedIn />
      <Box>
        <Grid container>
          {/* Box incluant l'image */}
          <Grid
            item
            sm={6}
            sx={{
              display: { xs: "none", sm: "block" },
            }}
          >
            <Box className="boxImageLogIn">
              <Box
                component="img"
                alt="Component"
                src="/login_screen_pic.png"
                className="imageLogIn"
              />
            </Box>
          </Grid>

          {/* Box generale du LogIn */}
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              alignItems: "center",
              // justifyContent: "center",
            }}
          >
            <Box className="boxLogIn">
              <Typography
                component="div"
                gutterBottom
                sx={{ fontWeight: "bold", fontSize: 30 }}
              >
                Bienvenue chez Carlo
              </Typography>
              <Typography
                component="div"
                gutterBottom
                sx={{ fontWeight: "bold", fontSize: 16 }}
              >
                Connexion avec L'Email
              </Typography>

              <TextField
                className={classes.field}
                // className="textField"
                label="Business Email"
                color="secondary"
                margin="normal"
                onChange={(e) => setEmail(e.target.value.toLocaleLowerCase())}
                onKeyDown={handleKeyDown}
                value={email}
              />

              <TextField
                id="outlined-pass"
                className={classes.field}
                color="secondary"
                label="Mot de passe"
                type={showPass ? "text" : "password"}
                margin="normal"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
                value={password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                      >
                        {showPass ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Box
                mt={1}
                mb={5}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {radio ? (
                    <IconButton onClick={() => setRadio(!radio)}>
                      <MdRadioButtonChecked />
                    </IconButton>
                  ) : (
                    <IconButton onClick={() => setRadio(!radio)}>
                      <MdRadioButtonUnchecked />
                    </IconButton>
                  )}

                  <Typography sx={{ color: "#17224D", fontSize: 14 }}>
                    Rester connecté
                  </Typography>
                </Box>
                <Link
                  href="#"
                  underline="always"
                  onClick={() => handleForgotPass()}
                  sx={{ color: "#006EFF", fontSize: 14 }}
                >
                  {"Mot de passe oublié ?"}
                </Link>

                {/* Modal pour l'oublie de mot de passe */}
                <Modal
                  open={openForgotPass}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      bgcolor: "background.paper",
                      p: 4,
                      borderRadius: 5,
                    }}
                  >
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      sx={{ fontWeight: "bold" }}
                    >
                      Réinitialiser votre mot de passe
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      Veuillez entrer votre adresse mail pour réinitialiser
                      votre mot de passe.
                    </Typography>
                    <TextField
                      // className={classes.field}
                      color="secondary"
                      label="Email"
                      margin="normal"
                      onChange={(e) => setForgotEmail(e.target.value)}
                      value={forgotEmail}
                    />
                    <Button
                      variant="contained"
                      onClick={() => handleConfirmForgotPass()}
                      sx={{ bgcolor: "#006EFF" }}
                    >
                      Confirmer
                      {resetEmail ? (
                        // Modal pour confirmer l'envoie d'email de recuperation de mdp
                        <Modal
                          open={openForgotPass}
                          onClose={handleClose}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              width: 400,
                              bgcolor: "background.paper",
                              p: 4,
                              borderRadius: 5,
                            }}
                          >
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h2"
                            >
                              Nous vous avons envoyé un e-mail avec votre
                              nouveau mot de passe.{" "}
                            </Typography>
                            <Button variant="contained" onClick={handleClose}>
                              OK
                            </Button>
                          </Box>
                        </Modal>
                      ) : (
                        <Redirect to="/" />
                      )}
                      {failResetEmail ? (
                        // Modal pour informer que l'email inserer n'existe pas
                        <Modal
                          open={openForgotPass}
                          onClose={handleClose}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              width: 400,
                              bgcolor: "background.paper",
                              p: 4,
                              borderRadius: 5,
                            }}
                          >
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h2"
                            >
                              Erreur, l'adresse email insérée n'existe pas
                            </Typography>
                            <Button
                              variant="contained"
                              onClick={handleClose}
                              sx={{ bgcolor: "#006EFF" }}
                            >
                              OK
                            </Button>
                          </Box>
                        </Modal>
                      ) : (
                        <Redirect to="/" />
                      )}
                    </Button>
                  </Box>
                </Modal>
              </Box>
              <Button
                variant="contained"
                size="large"
                type="submit"
                // ref={(node) => (this.btn = node)}
                onClick={() => handleLogIn()}
                // onSubmit={() => handleLogIn()}
                sx={{
                  bgcolor: "#006EFF",
                  width: 359,
                  ":hover": {
                    bgcolor: "#006EFF",
                  },
                }}
              >
                Se connecter
                {isLogin ? <Redirect to="/home" /> : <Redirect to="/" />}
              </Button>
              {/* </div> */}

              {/* Modal to show progress/wait */}

              <Modal open={openWait}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 5,
                  }}
                >
                  <LinearProgress />
                </Box>
              </Modal>

              {/*  */}

              {/* Modal to show there was an error */}

              <Modal open={openFailed}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 5,
                  }}
                >
                  <IconButton color="error" className={classes.icon}>
                    <MdError className={classes.icon} />
                  </IconButton>
                  <Typography mb={2} sx={{ fontWeight: "bold" }}>
                    L'email ou le mot de passe que vous avez insérez est
                    incorrect.
                  </Typography>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setOpenFailed(false)}
                  >
                    Fermer
                  </Button>
                </Box>
              </Modal>

              {/*Modal to show success reset mail  */}
              <Modal open={resetEmail}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 5,
                  }}
                >
                  <IconButton color="primary" className={classes.icon}>
                    <MdDone className={classes.icon} />
                  </IconButton>
                  <Typography mb={2} sx={{ fontWeight: "bold" }}>
                    Un nouveau mot de passe vous a été envoyé par mail.
                  </Typography>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setResetEmail(false)}
                  >
                    Fermer
                  </Button>
                </Box>
              </Modal>

              {/* Modal to show the reset email did not work */}

              <Modal open={failResetEmail}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 5,
                  }}
                >
                  <IconButton color="error" className={classes.icon}>
                    <MdError className={classes.icon} />
                  </IconButton>
                  <Typography mb={2} sx={{ fontWeight: "bold" }}>
                    L'email semble incorrect, veuillez réessayer ou nous
                    contacter.
                  </Typography>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setFailResetEmail(false)}
                  >
                    Fermer
                  </Button>
                </Box>
              </Modal>

              <Box
                mt={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="outlined"
                  href="/inscription"
                  sx={{
                    color: "#006EFF",
                    ":hover": {
                      color: "#006EFF",
                    },
                  }}
                >
                  {"Créer un compte"}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

export default connect(null, mapDispatchToProps)(LogIn);
